import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Col, Row, Table, Button, Input, Form, Label } from 'reactstrap';
import Pagination from 'react-js-pagination';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';
import moment from 'moment';

import { getOrdersCentral, downloadOrderData, getOrdersDetails, getRefundHistory, getBrandAndRestNames, getRestaurantGiftCardProviderSettings } from '../../actions';
import {
    DEFAULT_PAGE_SIZE,
    DEFAULT_PAGING_RANGE,
    ACCEPTED,
    REJECTED,
    PARTIALLY_REFUNDED,
    REFUNDED,
    CANCELED,
    PENDING,
    PENDING_IN_PROCESS,
    PENDING_FUTURE_ORDER,
    INSTORE_ID,
    CURBSIDE_ID
} from '../../utils/Constants';
import {
    getPriceWithCurrencySymbol,
    localizeCountryNames,
    localizeStatuses,
    transformProductPrice,
    getCurrencySymbolAccToCountry,
    renderOrderTypeSrc,
    renderPaymentTypeIcon,
    negativeIntegersValidation
} from '../../utils/CommonUtils';
import RestaurantUtils from '../../utils/RestaurantUtils';
import OrderDetailsScreen from '../restaurants/orders/OrderDetailsScreen';
import SearchButton from '../common/SearchButton';
import AutoCompleteSearch from './autosearch/AutoCompleteSearch';
import OrderSourceSelector from '../common/OrderSourceSelector';

class CentralOrdersLogScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currency: '',
            searchQuery: {
                orderId: '',
                customerName: '',
                customerEmail: '',
                customerPhone: '',
                brandName: '',
                restaurantName: '',
                orderDate: '',// REQURED format "dd-MM-yyyy" - this is the placedTime of the order 
                amount: '',
                paymentTypeId: '',
                orderTypeId: '',
                orderStatus: '',
                address: '',
                urgentOrder: false
            },

            ordersLog: [],
            currentPageNumber: 0,
            orderDetailsScreenOpened: false
        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.changeState = this.changeState.bind(this);
        this.search = this.search.bind(this);
        this.toggleOrderDetailsScreen = this.toggleOrderDetailsScreen.bind(this);
        this.getOrdersCentral = this.getOrdersCentral.bind(this);
    }

    componentDidMount() {
        this.getOrdersCentral();
        this.props.getBrandAndRestNames();
    }

    componentDidUpdate(prevProps) {
        if (this.props.ordersLog !== prevProps.ordersLog) {
            this.setState({
                ...this.state,
                ordersLog: this.props.ordersLog
            });
        }
    }

    changeState(e, inputData, inputName) {

        if (!e) {
            this.setState({
                ...this.state,
                currentPageNumber: 0,
                searchQuery: {
                    ...this.state.searchQuery,
                    [inputName]: inputData[inputName],
                    [`${inputName}Data`]: inputData
                }
            });

            return;
        }

        let targetValue = e.target.value;
        if (e.target.name === 'orderDate') {
            targetValue = e.target.value.split(/\D/);
            targetValue = new Date(targetValue[0], --targetValue[1], targetValue[2]);
            targetValue = moment(targetValue).format("DD-MM-YYYY")
        } else if (e.target.name === 'urgentOrder') {
            targetValue = e.target.checked;
        }

        this.setState({
            currentPageNumber: 0,
            searchQuery: {
                ...this.state.searchQuery,
                [e.target.name]: targetValue
            },
        });
    }

    getOrdersCentral() {
        this.props.getOrdersCentral(0, this.state.searchQuery)
    }

    search() {
        this.props.getOrdersCentral(this.state.currentPageNumber, this.state.searchQuery);
    }

    clearSearch() {
        //new search should always start from page 1
        this.setState({
            searchQuery: {
                orderId: '',
                customerName: '',
                customerEmail: '',
                customerPhone: '',
                brandName: '',
                restaurantName: '',
                orderDate: '',// REQURED format "dd-MM-yyyy" - this is the placedTime of the order 
                amount: '',
                paymentTypeId: '',
                orderTypeId: '',
                orderStatus: '',
                address: '',
                urgentOrder: false
            },
            currentPageNumber: 0
        },
            () => {
                document.getElementById("orderDate").value = '';
                this.props.getOrdersCentral(this.state.currentPageNumber, this.state.searchQuery);
            });
    }

    onKeyUp(event) {
        event.preventDefault();
        if (event.keyCode === 13) {
            document.getElementById('advanceSearchButton').click();
        }
    }

    renderSearch() {
        const { paddingLeftRight, orderIdCol, zeroPadding } = styles;
        const {
            orderId,
            customerName,
            customerEmail,
            customerPhone,
            brandName,
            restaurantName,
            amount,
            paymentTypeId,
            orderTypeId,
            orderStatus,
            address,
            urgentOrder } = this.state.searchQuery;

        return (
            <Col xs="auto" sm={12} >
                <Form id='advanceSearchForm' onKeyUp={this.onKeyUp}>
                    <Row>
                        <Col style={orderIdCol}>
                            <Input type="number" name="orderId" id="orderId" placeholder={i18n.t('screens:orderHistoryScreen.orderId')} value={orderId} onChange={this.changeState} className={"inputOrderId"} onKeyPress={(e) => negativeIntegersValidation(e)}/>
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="date" name="orderDate" id="orderDate" placeholder={i18n.t('screens:orderHistoryScreen.orderDate')} onChange={this.changeState} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="text" name="address" id="address" placeholder={i18n.t('screens:orderHistoryScreen.address')} value={address} onChange={this.changeState} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="text" name="customerName" id="customerName" placeholder={i18n.t('screens:orderHistoryScreen.customerName')} value={customerName} onChange={this.changeState} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="text" name="customerPhone" id="customerPhone" placeholder={i18n.t('screens:orderHistoryScreen.customerPhone')} value={customerPhone} onChange={this.changeState} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="text" name="customerEmail" id="customerEmail" placeholder={i18n.t('screens:orderHistoryScreen.customerEmail')} value={customerEmail} onChange={this.changeState} />
                        </Col>
                    </Row>
                    <Row>
                        <Col style={zeroPadding}>
                            <Input type="select" name="paymentTypeId" id="paymentTypeId" placeholder={i18n.t('screens:orderHistoryScreen.paymentTypeId')} value={paymentTypeId} onChange={this.changeState}>
                                <option value=''>{i18n.t('screens:centralOrdersLog.selectPayment')}</option>
                                <option value='1'>{i18n.t('screens:centralOrdersLog.card')}</option>
                                <option value='2'>{i18n.t('screens:centralOrdersLog.cash')}</option>
                            </Input>
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="select" name="orderTypeId" id="orderTypeId" placeholder={i18n.t('screens:orderHistoryScreen.orderTypeId')} value={orderTypeId} onChange={this.changeState}>
                                <option value=''>{i18n.t('screens:centralOrdersLog.selectOrderType')}</option>
                                <option value='1'>{i18n.t('screens:centralOrdersLog.delivery')}</option>
                                <option value='2'>{i18n.t('screens:centralOrdersLog.collection')}</option>
                                <option value='4'>{i18n.t('screens:centralOrdersLog.curbside')}</option>
                                <option value='5'>{i18n.t('screens:centralOrdersLog.inStore')}</option>
                            </Input>
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="select" name="orderStatus" id="orderStatus" placeholder={i18n.t('screens:orderHistoryScreen.orderStatus')} value={orderStatus} onChange={this.changeState}>
                                <option value=''>{i18n.t('screens:centralOrdersLog.selectStatus')}</option>
                                <option value={ACCEPTED}>{localizeStatuses(ACCEPTED)}</option>
                                <option value={REJECTED}>{localizeStatuses(REJECTED)}</option>
                                <option value={PARTIALLY_REFUNDED}>{localizeStatuses(PARTIALLY_REFUNDED)}</option>
                                <option value={REFUNDED}>{localizeStatuses(REFUNDED)}</option>
                                <option value={CANCELED}>{localizeStatuses(CANCELED)}</option>
                                <option value={PENDING}>{localizeStatuses(PENDING)}</option>
                                <option value={PENDING_IN_PROCESS}>{localizeStatuses(PENDING_IN_PROCESS)}</option>
                                <option value={PENDING_FUTURE_ORDER}>{localizeStatuses(PENDING_FUTURE_ORDER)}</option>
                            </Input>
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="text" name="amount" id="amount" placeholder={i18n.t('screens:orderHistoryScreen.amount')} value={amount} onChange={this.changeState} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <AutoCompleteSearch
                                inputId='brandName'
                                inputName='brandName'
                                placeholder={i18n.t('screens:jobsHistoryScreen.brandName')}
                                inputValue={brandName}
                                inputStyle={{}}
                                changeState={this.changeState}
                                searchValues={this.props.brandNames} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <AutoCompleteSearch
                                inputId='restaurantName'
                                inputName='restaurantName'
                                placeholder={i18n.t('screens:generalScreen.restaurantName')}
                                inputValue={restaurantName}
                                inputStyle={{}}
                                changeState={this.changeState}
                                comparisonValue={brandName}
                                searchValues={this.props.restaurantNames} />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col style={{ ...paddingLeftRight, ...{ maxWidth: 180, maxHeight: 46, display: 'flex', alignItems: 'center' } }}>
                            <Label for='urgentOrder' style={{ marginBottom: 0 }}>{i18n.t('screens:centralOrdersLog.urgentFilter')}</Label>
                            <Input type='checkbox' id='urgentOrder' name='urgentOrder' onChange={this.changeState} checked={urgentOrder}
                                style={{ position: 'relative', marginLeft: 10 }} />
                        </Col>
                        <Col style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 0 }}>
                            <Button
                                color='primary'
                                onClick={() => this.props.downloadOrderData(this.state.currentPageNumber, this.state.searchQuery)}
                            >
                                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                                    <MaterialIcon icon="cloud_download" color="#fff" size={19} />
                                    <span style={{ marginLeft: 6 }}>{i18n.t('screens:centralOrdersLog.download')}</span>
                                </div>
                            </Button>

                            <Col style={{ maxWidth: 190, display: 'flex', alignItems: 'flex-end', flexDirection: 'column', padding: 0 }}>
                                <SearchButton search={this.search} />
                                <Button
                                    color="link"
                                    style={{ paddingTop: 0, paddingRight: 0, minWidth: 80, textAlign: 'right' }}
                                    onClick={() => this.clearSearch()}>{i18n.t('common:searchForms.clear')}
                                </Button>
                            </Col>
                        </Col>
                    </Row>
                </Form>
            </Col>
        );
    }

    renderOrderHistoryTable() {
        const { zeroPadding, textAlignCenter } = styles;

        return (
            <Col style={zeroPadding}>
                <Table responsive hover>
                    <thead>
                        <tr>
                            <th>{i18n.t('screens:orderHistoryScreen.orderIdTable')}</th>
                            <th>{i18n.t('screens:restaurantsScreen.brand')}</th>
                            <th>{i18n.t('screens:centralOrdersLog.restaurant')}</th>
                            <th>{i18n.t('screens:restaurantsScreen.location')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.date')}</th>
                            <th style={textAlignCenter}>{i18n.t('screens:orderHistoryScreen.orderType')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.customerName')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.orderAddress')}</th>
                            <th style={textAlignCenter}>{i18n.t('screens:orderHistoryScreen.paymentType')}</th>
                            <th>{i18n.t('screens:orderDetailsScreen.totalPrice')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.status')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.source')}</th>
                            <th>{i18n.t('screens:orderDetailsScreen.rejectReason')}</th>
                            <th>{i18n.t('screens:centralOrdersLog.urgentOrder')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.ordersLog.content && this.state.ordersLog.content.length ?
                                this.renderTableRows() :
                                <tr>
                                    <td colspan='13'>{i18n.t('screens:centralOrdersLog.noResults')}</td>
                                </tr>
                        }
                    </tbody>
                </Table>
            </Col>
        );
    }

    renderTableRows() {
        const { selectOrderStyle, textAlignCenter, loyaltyIconStyle } = styles;
        const currency = this.state.currency;
        const content = this.state.ordersLog.content ? this.state.ordersLog.content : null;

        if (content !== undefined && content !== null && content.length) {
            return content.map((order, i) => {

                let orderStatusColor = RestaurantUtils.getOrderStatusColor(order.orderStatus);
                const statusColor = { color: orderStatusColor };

                let orderAddress = (order.orderAddress.fullAddress !== null) ? order.orderAddress.fullAddress : order.orderAddress.street + ', ' + order.orderAddress.city + ', ' + localizeCountryNames(order.orderAddress.country);
                if (order.orderType.id === INSTORE_ID) {
                    orderAddress = order.inStoreSeat;
                } else if (order.orderType.id === CURBSIDE_ID) {
                    orderAddress = order.carDetails;
                }
                
                const orderTypeIconSrc = renderOrderTypeSrc(order.orderType.id);

                let paymentTypeIconSrc = renderPaymentTypeIcon(order.tenderType.id);
                const orderServiceFee = order.serviceFee ? order.serviceFee : 0;

                let price = parseFloat(order.priceTotal) + orderServiceFee;

                let renderLoyaltyIcon = order.paidWithVoucher;

                const priceTotalWithCurrency = getPriceWithCurrencySymbol(transformProductPrice(price), getCurrencySymbolAccToCountry(order.orderAddress.country));

                const isOnlyLoyalty = renderLoyaltyIcon && price === 0 ? true : false;

                if (isOnlyLoyalty) {
                    paymentTypeIconSrc = null;
                }

                const isLoyaltyIconStyle = renderLoyaltyIcon && paymentTypeIconSrc ? loyaltyIconStyle : null;
                const loyaltyIconSrc = renderPaymentTypeIcon(3, isLoyaltyIconStyle, isOnlyLoyalty); // Loyalty fake id
                const isGiftCardDiscount = order.giftCardDiscount ? true : false;

                return (
                    <tr key={i}>
                        <td style={selectOrderStyle} onClick={() => this.loadOrderDetailsScreen(order.orderId, order.restaurantId)}>{order.orderId}</td>
                        <td>{order.brandName}</td>
                        <td>{order.restaurantName}</td>
                        <td>{order.restaurantLocation}</td>
                        <td>{order.date}</td>
                        <td style={textAlignCenter}>{orderTypeIconSrc}</td>
                        <td>{order.customerName}</td>
                        <td>{orderAddress}</td>
                        <td style={textAlignCenter}>
                            <div style={{display: 'flex'}}> 
                            {
                                renderLoyaltyIcon && paymentTypeIconSrc ?
                                <React.Fragment>
                                    <span style={{display: 'flex', justifyContent: 'space-evenly'}}>
                                    {paymentTypeIconSrc}
                                        {loyaltyIconSrc}
                                    </span>
                                </React.Fragment> :
                                renderLoyaltyIcon && !paymentTypeIconSrc ? loyaltyIconSrc : paymentTypeIconSrc
                            }
                            {
                                isGiftCardDiscount ? 
                                <span style={{marginLeft: '11px'}}>
                                    <MaterialIcon icon="card_giftcard" size={28} width={24} height={26} color='#0288d1' />
                                </span> : null
                            }
                            </div>
                        </td>
                        <td>{priceTotalWithCurrency}</td>
                        <td><span style={statusColor}>{(order.orderStatus !== null) ? localizeStatuses(order.orderStatus) : i18n.t('screens:centralOrdersLog.noStatus')}</span></td>
                        <td>
                            <OrderSourceSelector source={order.source} />
                        </td>
                        <td>{order.rejectReason ? i18n.t(`screens:mainContainer.${order.rejectReason}`) : null}</td>
                        <td>
                            {
                                !order.urgentOrder ? '-' :
                                    <MaterialIcon icon='done' color='rgb(191, 30, 46)' size={28} />
                            }
                        </td>
                    </tr>
                );
            });
        };
    }

    loadOrderDetailsScreen(orderId, restaurantId) {
        this.props.getOrdersDetails(orderId, () => {
            this.toggleOrderDetailsScreen();
        });

        this.props.getRefundHistory(orderId);
        this.props.getRestaurantGiftCardProviderSettings(restaurantId);
    }

    toggleOrderDetailsScreen() {
        this.setState({
            orderDetailsScreenOpened: !this.state.orderDetailsScreenOpened
        });
    }

    rejectedOrderReseted() {
        this.props.getOrdersCentral(0, this.state.searchQuery);
    }

    renderPagination() {
        const { flexEnd } = styles;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={this.props.ordersLog.number + 1}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={this.props.ordersLog.totalElements}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handlePageChange}
                />
            </Col>
        );
    }

    handlePageChange(pageNumber) {
        this.setState({
            currentPageNumber: (pageNumber - 1)
        }, () => this.props.getOrdersCentral(this.state.currentPageNumber, this.state.searchQuery));
    }

    render() {
        const { containerStyle } = styles;

        return (
            <Container fluid style={containerStyle}>
                <Row>{this.renderSearch()}</Row>
                <Row>{this.renderOrderHistoryTable()}</Row>
                <Row>{this.renderPagination()}</Row>
                {
                    !this.state.orderDetailsScreenOpened ? null :
                        <OrderDetailsScreen
                            isOpen={this.state.orderDetailsScreenOpened}
                            onToggle={this.toggleOrderDetailsScreen}
                            orderDetails={this.props.orderDetails}
                            currentPageNumber={this.state.currentPageNumber}
                            rejectedOrderReseted={this.rejectedOrderReseted.bind(this)}
                            getOrdersCentral={this.props.getOrdersCentral}
                            searchQuery={this.state.searchQuery}
                            refreshResults={this.getOrdersCentral}
                            giftCardProviderType={this.props.giftCardProvider.restaurantGiftCardProviderTypeId ? this.props.giftCardProvider.restaurantGiftCardProviderTypeId.type : null}
                        />
                }
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        ordersLog: state.ordersLog.orders,
        brandNames: state.ordersLog.brandNames,
        restaurantNames: state.ordersLog.restaurantNames,
        orderDetails: state.оrderDetails,
        giftCardProvider: state.giftCardProvider
    }
}

export default connect(mapStateToProps, { getOrdersCentral, downloadOrderData, getOrdersDetails, getRefundHistory, getBrandAndRestNames, getRestaurantGiftCardProviderSettings })(CentralOrdersLogScreen);

let styles = {
    containerStyle: {
        width: '96%',
        marginTop: 20
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    },
    inputGroupSearch: {
        border: '1px solid lightgray'
    },
    inputSearch: {
        border: 0
    },
    paddingLeftRight: {
        paddingLeft: 5,
        paddingRight: 0,
        marginBottom: 5
    },
    rowMarginBottom: {
        marginBottom: 10
    },
    simpleSearchPipe: {
        height: 46,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '10px 0',
        color: '#007bff'
    },
    inputGroupAddon: {
        marginTop: '10px'
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    advancedSearchPipe: {
        height: 46,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '10px 0',
        color: '#007bff'
    },
    searchButtonStyle: {
        width: '100%',
        verticalAlign: 'middle !important'
    },
    zeroPadding: {
        paddingLeft: 0,
        paddingRight: 0
    },
    orderIdCol: {
        paddingLeft: 0,
        paddingRight: 0
    },
    selectOrderStyle: {
        color: '#0087d7',
        cursor: 'pointer'
    },
    textAlignCenter: {
        textAlign: 'center'
    },
    loyaltyIconStyle: {
        marginLeft: '11px'
    }
}


// WEBPACK FOOTER //
// ./src/components/central/CentralOrdersLogScreen.js